export const FONT_VARIANT = "font-adobe italic text-[3rem] md:text-[4rem]"

// Improved color with better contrast ratio for accessibility
export const SECONDARY_TEXT_COLOR = "#c4bfb7" // Improved from #a19b92 for better contrast
